export enum ContactType {
    CELLPHONE = 1001,
    EMAIL = 1002
}